import { Navigate, useRoutes } from 'react-router-dom';

// ----------------------------------------------------------------------//

// Layouts de navegação
import AppNavigation from './layouts/appnavigation';
import LogoOnlyLayout from './layouts/LogoOnlyLayouts';

// Paginas
import Home from './pages/Home';
// import Login from './pages/Auth';
import NotFound from './pages/Page404';
import Chat from './pages/Chat';

import UserListPage from './layouts/appnavigation/UserListPage';
import Dashboard from './layouts/appnavigation/Dashboard';

// ----------------------------------------------------------------------//

export default function Router() {
  return useRoutes([
    {
      path: '/users',
      element: <UserListPage />,
    },
    {
      path: '/app',
      element: <AppNavigation />,
      children: [
        { path: 'home', element: <Home /> },
        // { path: 'chat/:id/:name', element: <Chat /> },
        { path: 'chat', element: <Chat /> },
        { path: 'users', element: <UserListPage /> },
        { path: 'dashboard', element: <Dashboard /> },
      ],
    },
    {
      path: '/',
      element: <LogoOnlyLayout />,
      children: [
        { path: '/', element: <Navigate to="/app/home" /> },
        // { path: 'login', element: <Login /> },
        { path: '404', element: <NotFound /> },
        { path: '*', element: <Navigate to="/404" /> },
      ],
    },
    { path: '*', element: <Navigate to="/404" replace /> },
  ]);
}
